import { API } from "@/lib/api";

async function request(path, options = {}) {
  const res = await fetch(`${API}/predictmarkets${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    let detail = "Predictmarkets request failed.";
    try {
      const body = await res.json();
      detail = body?.detail || body?.message || body?.error || detail;
    } catch {
      detail = await res.text().catch(() => detail);
    }
    throw new Error(typeof detail === "string" ? detail : "Predictmarkets request failed.");
  }
  return res.json();
}

export const predictmarketsApi = {
  status: () => request("/status"),
  analytics: () => request("/analytics"),
  sync: () => request("/sync", { method: "POST", body: "{}" }),
  syncFull: () => request("/sync/full", { method: "POST", body: "{}" }),
  syncFullStatus: () => request("/sync/full/status"),
  markets: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") q.set(key, String(value));
    });
    return request(`/markets?${q.toString()}`);
  },
  market: (id) => request(`/markets/${encodeURIComponent(id)}`),
  signals: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") q.set(key, String(value));
    });
    return request(`/signals?${q.toString()}`);
  },
  refreshSignals: () => request("/signals/refresh", { method: "POST", body: "{}" }),
  analyze: (payload) => request("/analysis", { method: "POST", body: JSON.stringify(payload) }),
  analyses: () => request("/analyses"),
  arbitrage: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") q.set(key, String(value));
    });
    return request(`/arbitrage?${q.toString()}`);
  },
  strategy: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") q.set(key, String(value));
    });
    return request(`/strategy?${q.toString()}`);
  },
  recordDecision: (payload) => request("/decisions", { method: "POST", body: JSON.stringify(payload) }),
  scanner: () => request("/scanner"),
  whales: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") q.set(key, String(value));
    });
    return request(`/whales?${q.toString()}`);
  },
  whaleStory: (wallet) => request(`/whales/${encodeURIComponent(wallet)}/story`),
  watchlist: () => request("/watchlist"),
  addWatch: (payload) => request("/watchlist", { method: "POST", body: JSON.stringify(payload) }),
  updateWatch: (marketId, payload) => request(`/watchlist/${encodeURIComponent(marketId)}`, { method: "PATCH", body: JSON.stringify(payload) }),
  removeWatch: (marketId) => request(`/watchlist/${encodeURIComponent(marketId)}`, { method: "DELETE" }),
  alerts: () => request("/alerts"),
  createAlert: (payload) => request("/alerts", { method: "POST", body: JSON.stringify(payload) }),
  toggleAlert: (alertId) => request(`/alerts/${encodeURIComponent(alertId)}/toggle`, { method: "PUT", body: "{}" }),
  deleteAlert: (alertId) => request(`/alerts/${encodeURIComponent(alertId)}`, { method: "DELETE" }),
  exportData: (kind) => request(`/export/${encodeURIComponent(kind)}`),
};